<template functional>
  <dl v-if="props.mandatory || $scopedSlots.default" class="dl1" :class="[data.class, data.staticClass]">
    <slot />
  </dl>
</template>

<script>
export default {
  name: 'DescriptionList',

  props: {
    mandatory: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

.dl1 ::v-deep {
  padding: 6px 0 0;
  margin: 0;

  dt {
    font-weight: 600;

    button.pull-right {
      margin-top: 4px;
      margin-left: 6px;
    }
  }

  dd {
    padding: 3px 0 6px;
    margin: 0 0 6px;
    color: $color-gray;
    word-wrap: break-word;
    border-bottom: 1px solid $color-border-bright;

    &::after {
      display: table;
      clear: both;
      content: '';
    }

    .badge {
      float: right;
      padding-bottom: 4px;
      margin-top: -21px;
      margin-left: 6px;
    }
  }

  dd:last-of-type {
    padding-bottom: 0;
    margin-bottom: 0;
    border-bottom: none;
  }

  dd:empty::after {
    line-height: $line-height-regular;
    white-space: pre;
    content: ' ';
  }
}

.dl1.no-spacing {
  padding-top: 0;
}

.dl1.line ::v-deep {
  dd:last-of-type {
    padding: 3px 0 6px;
    color: $color-gray;
    border-bottom: 1px solid $color-border-bright;
  }
}

@media screen and (max-width: #{$grid-small-min}px) {
  .dl1 ::v-deep {
    dt button.pull-right {
      float: none;
      width: 100%;
      margin-left: 0;
    }
    dd .badge {
      float: none;
      width: 100%;
      margin-left: 0;
    }
  }
}

@media screen and (max-width: #{$grid-medium-max}px) {
  .bottom-line-m ::v-deep {
    padding-bottom: 6px;
    border-bottom: 1px solid $color-border-bright;
  }
}
</style>
